import { render, staticRenderFns } from "./mainList.vue?vue&type=template&id=fa81c440&scoped=true"
import script from "./mainList.vue?vue&type=script&lang=js"
export * from "./mainList.vue?vue&type=script&lang=js"
import style0 from "./mainList.vue?vue&type=style&index=0&id=fa81c440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81c440",
  null
  
)

export default component.exports